import {apiService} from '../apiService';
import type {Customer, PaginatedResponse} from 'shared-types';

export const customerApi = {
    // GET routes based on actual backend
    getAll: (): Promise<Customer[]> =>
        apiService.get('/customers'),

    getPage: (page: number, limit: number): Promise<PaginatedResponse<Customer>> =>
        apiService.get(`/customers/page?page=${page}&limit=${limit}`),

    getById: (id: string): Promise<Customer> =>
        apiService.get(`/customers/${id}`),

    search: (text: string): Promise<Customer[]> =>
        apiService.get(`/customers/search?text=${text}`),

    getAllStatus: (): Promise<any[]> =>
        apiService.get('/customers/status/all'),

    getCustomersToNotify: (id: string): Promise<any[]> =>
        apiService.get(`/customers/notify/${id}`),

    getPaymentMethods: (id: string): Promise<any[]> =>
        apiService.get(`/customers/${id}/payment-methods`),

    confirmEmail: (id: string, email: string): Promise<void> =>
        apiService.get(`/customers/confirm-email/${id}/${email}`),

    sendContractEmail: (link: string): Promise<void> =>
        apiService.get(`/customers/sendEmailWithContract/${link}`),

    // POST routes
    create: (customer: Partial<Customer>): Promise<Customer> =>
        apiService.post('/customers/post-customer', customer),

    sendExitNotice: (id: string, exitData: any): Promise<void> =>
        apiService.post(`/customers/${id}/exit-notice`, exitData),

    changeStatus: (id: string, statusData: any): Promise<void> =>
        apiService.post(`/customers/${id}/status-change`, statusData),

    uploadExcel: (file: File): Promise<any> =>
        apiService.uploadFile('/customers/upload/excel', file),

    // PATCH/DELETE routes
    update: (id: string, customer: Partial<Customer>): Promise<Customer> =>
        apiService.patch(`/customers/${id}`, customer),

    delete: (id: string): Promise<void> =>
        apiService.delete(`/customers/${id}`),
};